import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import Weddings from "@/pages/Weddings";
import WorkWithUs from "@/pages/WorkWithUs";
import RequestQuote from "@/pages/RequestQuote";
import Menus from "@/pages/Menus";
import GalleryPage from "@/pages/GalleryPage";
import { LanguageProvider } from "@/lib/i18n";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <LanguageProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/weddings" element={<Weddings />} />
            <Route path="/work-with-us" element={<WorkWithUs />} />
            <Route path="/request-a-quote" element={<RequestQuote />} />
            <Route path="/menus" element={<Menus />} />
            <Route path="/gallery" element={<GalleryPage />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
